import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 24, height = 24, color = 'currentColor', customClass = '' }: IconComponentProps) => <svg aria-hidden='true' width={width} height={height} viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class={customClass}>
    <path d="M0 8L5 0L10 8H0Z" fill={color}/>
</svg>
